'use client';

import { useCallback } from 'react';

import { useModalStore } from '@/stores';

import {
  OtpVerificationModal,
  type OtpDescription,
  type OtpVerifyResult,
} from '../OtpVerificationModal';

type OpenOtpVerificationModalArgs = {
  maskedPhone?: string;
  title?: string;
  description?: OtpDescription;
  onVerify: (code: string) => Promise<OtpVerifyResult>;
  onResend: () => Promise<string | undefined>;
  onSuccess?: () => void;
};

export const useOtpVerificationModal = () => {
  const openModal = useModalStore((state) => state.openModal);
  const closeModal = useModalStore((state) => state.closeModal);

  const openOtpVerificationModal = useCallback(
    ({
      maskedPhone,
      title,
      description,
      onVerify,
      onResend,
      onSuccess,
    }: OpenOtpVerificationModalArgs) => {
      const modalId = openModal({
        showCloseButton: true,
        hardClose: false,
        priority: 100,
        className: '!h-auto !max-h-none w-[calc(100%-2rem)] max-w-sm mx-auto my-auto',
        Component: () => (
          <OtpVerificationModal
            maskedPhone={maskedPhone}
            title={title}
            description={description}
            onVerify={onVerify}
            onResend={onResend}
            onSuccess={onSuccess}
            onClose={() => closeModal(modalId)}
          />
        ),
      });

      return modalId;
    },
    [openModal, closeModal],
  );

  return { openOtpVerificationModal };
};
